module.exports = __webpack_public_path__ + "img/project-vomer.4949a907.png";